<script>
import { AuthLayout } from '@/components/layout'
import { authMethods } from '@/state/helpers'
import appConfig from '@/app.config'

import { required, email } from 'vuelidate/lib/validators'

/**
 * Forgot Password component
 */
export default {
  page: {
    title: 'Forgot Password',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { AuthLayout },
  data () {
    return {
      email: '',
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false
    }
  },
  validations: {
    email: { required, email }
  },
  methods: {
    ...authMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset () {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      } else {
        this.tryingToReset = true
        // Reset the authError if it existed.
        this.error = null
        return (
          this.resetPassword({
            email: this.email
          })
            // eslint-disable-next-line no-unused-vars
            .then(token => {
              this.tryingToReset = false
              this.isResetError = false
            })
            .catch(error => {
              this.tryingToReset = false
              this.error = error ? error : ''
              this.isResetError = true
            })
        )
      }
    }
  }
}
</script>

<template>
  <AuthLayout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Reset Password</h5>
                  <p>Re-Password with Skote.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <div class="p-2">
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ error }}</b-alert
              >
              <form @submit.prevent="tryToReset">
                <div class="form-group">
                  <label for="useremail">Email</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="useremail"
                    placeholder="Enter email"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div
                    v-if="submitted && $v.email.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">Email is required.</span>
                    <span v-if="!$v.email.email"
                      >Please enter valid email.</span
                    >
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <div class="col-12 text-right">
                    <button class="btn btn-primary w-md" type="submit">
                      Reset
                    </button>
                  </div>
                </div>

                <div class="mt-4 text-center">
                  Remember It ?

                  <router-link
                    tag="a"
                    to="/login"
                    class="font-weight-medium text-primary"
                    >Sign In here</router-link
                  >
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-3 text-center">
          <p>© {{ new Date().getFullYear() }} OMS bv.</p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </AuthLayout>
</template>

<style lang="scss" module></style>
